
// const rootUrl = 'https://t13301.centaline-sc.com/charge-manage'
// const rootUrl = '/charge-manage'

const rootUrl = 'https://cdcharge.centaline.com.cn/charge-manage'
//const rootUrl = 'http://localhost:8080'
export default rootUrl;